<template>
  <div class="innerBody">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>积分商品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="pageparm" class="user-search">
      <el-form-item label="搜索：">
        <el-select
          size="small"
          v-model="pageparm.onSale"
          placeholder="请选择商品状态"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleEdit()"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="id" label="商品ID"> </el-table-column>
      <el-table-column prop="image" label="商品图片">
        <template slot-scope="scope">
          <img
            :src="$store.state.fileBaseUrl + scope.row.image"
            alt=""
            style="width: 100px; height: 100px"
          />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="商品标题"> </el-table-column>
      <el-table-column prop="pointsPrice" label="兑换积分"> </el-table-column>
      <el-table-column prop="stock" label="商品库存"> </el-table-column>
      <el-table-column prop="onSale" label="当前状态">
        <template slot-scope="scope">
          <div>
            <el-tag type="success" v-show="scope.row.onSale == 1">在售中</el-tag>
            <el-tag type="danger" v-show="scope.row.onSale == 0">已下架</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="takenOff(scope.$index, scope.row)"

            v-show="scope.row.onSale == 1"
            >下架</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="takenOn(scope.$index, scope.row)"
             v-show="scope.row.onSale == 0"
            >上架</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagtion">
      <Pagination
        v-bind:child-msg="pageparm"
        @callFather="callFather"
      ></Pagination>
    </div>

    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="40%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="商品名称" prop="name">
          <el-input
            size="small"
            v-model="editForm.name"
            auto-complete="off"
            placeholder="请输入商品名称"
          ></el-input>
        </el-form-item>
        <!-- Body：name、、（必填）；；image、（可选）；新建默认上架 -->
        <el-form-item label="兑换积分" prop="pointsPrice">
          <el-input
            size="small"
            type="number"
            v-model="editForm.pointsPrice"
            auto-complete="off"
            placeholder="请输入商品兑换所需积分"
            ><template slot="append">分</template></el-input
          >
        </el-form-item>

        <el-form-item label="商品图片" prop="image">
          <upImg v-model="editForm.image"></upImg>
        </el-form-item>

        <el-form-item label="商品库存" prop="stock">
          <el-input
            size="small"
            type="number"
            v-model="editForm.stock"
            auto-complete="off"
            placeholder="请输入商品库存"
            ><template slot="append">个</template></el-input
          >
        </el-form-item>

        <el-form-item label="商品介绍" prop="description"> </el-form-item>
        <div style="padding-left: 40px; min-height: 200px">
          <editor v-model="editForm.description"> </editor>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import upImg from "../../components/upImg.vue";
import editor from "../../components/editor.vue";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        id: "",
        name: "",
        pointsPrice: "",
        stock: "",
        image: "",
        description: "",
      },
      rules: {
        name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        pointsPrice: [
          {
            required: true,
            message: "请输入商品兑换所需积分",
            trigger: "blur",
          },
        ],
        image: [{ required: true, message: "请上传商品图片", trigger: "blur" }],
        stock: [{ required: true, message: "请输入商品库存", trigger: "blur" }],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "明天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "三天后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      listData: [],
      pageparm: {
        pageNum: 1,
        pageSize: 10,
        total: 10,
        onSale: "",
      },
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "在售中",
        },
        {
          value: "0",
          label: "已下架",
        },
      ],
    };
  },
  // 注册组件
  components: {
    Pagination,
    upImg,
    editor,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.pageparm);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getdata(parameter) {
      this.loading = true;
      this.$request
        .getGoods(parameter)
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          this.listData = res.data.list;
          // // 分页赋值
          this.pageparm.pageNum = res.data.pageNum;
          this.pageparm.pageSize = res.data.pageSize;
          this.pageparm.total = res.data.total;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageNum = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.getdata(this.pageparm);
    },
    // 搜索事件
    search() {
      this.getdata(this.pageparm);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.id = row.id;
        this.editForm.name = row.name;
        this.editForm.image = row.image;
        this.editForm.stock = row.stock;
        this.editForm.pointsPrice = row.pointsPrice;
        this.editForm.description = row.description;
      } else {
        delete this.editForm.id;
        this.title = "添加";
        this.editForm.name = "";
        this.editForm.image = "";
        this.editForm.stock = "";
        this.editForm.pointsPrice =  "";
        this.editForm.description =  "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {


      this.$refs[editData].validate((valid) => {
        if (valid) {
         
          this.$request
            .addGoods(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              this.getdata(this.pageparm);
              this.$message({
                type: "success",
                message: "保存成功！",
              });
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    takenOff(index, row) {
      this.$confirm("确定要下架该商品吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$request
            .offlineGoods({ id: row.id })
            .then((res) => {
              this.$message({
                type: "success",
                message: "下架成功!",
              });
              this.getdata(this.pageparm);
            })
            .catch((err) => {
              this.loading = false;
            });
        })
    },
    takenOn(index, row) {
      this.$confirm("确定要重新上架该商品吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          this.$request
            .onlineGoods({ id: row.id })
            .then((res) => {
              this.$message({
                type: "success",
                message: "下架成功!",
              });
              this.getdata(this.pageparm);
            })
            .catch((err) => {
              this.loading = false;
            });
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.box {
  display: flex;
}


</style>





// WEBPACK FOOTER //
// src/views/goods/goods.vue